var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SplashScreen extends Component {
    constructor() {
        super('SplashScreen', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (sessionStorage.getItem('splash-screen-reduced') === 'true') {
                $('.splash-screen').addClass('splash-screen-reduced');
                $('.header').addClass('header-reduced');
            }
            else {
                if ($('body').hasClass('home'))
                    $('body').addClass('no-scroll');
            }
            setTimeout(() => {
                $('.splash-screen').addClass('is-animated');
                $('.header').addClass('is-animated');
            }, 500);
            $('.home .header-menu a, .splash-screen').on('click', (event, button) => {
                if ($('.splash-screen').hasClass('splash-screen-reduced'))
                    return;
                $('.sub-menu, .grid-view').addClass('d-none');
                $('.splash-screen').addClass('splash-screen-reduced');
                $('.header').addClass('header-reduced');
                $('body').removeClass('no-scroll');
                sessionStorage.setItem('splash-screen-reduced', 'true');
                event.preventDefault();
                if (!button.hasClass('btn-close-splash-screen') && button.attr('href')) {
                    $('.sub-menu, .grid-view').remove();
                    setTimeout(() => {
                        window.location.href = button.attr('href');
                    }, 500);
                }
                else {
                    setTimeout(() => {
                        $('.sub-menu, .grid-view').removeClass('d-none');
                    }, 500);
                }
            });
            $('.logo-link').on('click', () => {
                sessionStorage.setItem('splash-screen-reduced', 'false');
            });
            this.success();
        });
    }
}
